import produce from 'immer';

import { ChatModel } from '../../models/chat';
import { ActionType, ActionTypes } from './actions';

export interface chatState {
  chats: ChatModel[];
  currentChat: ChatModel | null;
}

export const initialChatModel: ChatModel = {
  id: '',
  name: '',
  created_dt: new Date(),
  recent_message_created_dt: undefined
};

export const initialState: chatState = {
  chats: [],
  currentChat: null,
};

export const chatReducer = produce((draft: chatState, action: ActionTypes) => {

  switch (action.type) {
    case ActionType.SET_CHATS:
      draft.chats = action.payload;
      break;
    case ActionType.SET_CURRENT_CHAT:
      let currentChat = draft.chats.find(cls => cls.id == action.payload)
      if( currentChat ){
        draft.currentChat = currentChat
      }else{
        draft.currentChat = null
      }
      break;
    case ActionType.ADD_CHAT:
      draft.chats.unshift(action.payload);
      break;
    case ActionType.DELETE_CHAT:
      draft.chats = draft.chats.filter(chat => chat.id !== action.payload)
      break;
    case ActionType.PATCH_CHAT:
      let chatIndexToPatch = draft.chats.findIndex(chat => chat.id === action.payload.id)
      if (chatIndexToPatch !== -1) {
        draft.chats[chatIndexToPatch] = { ...draft.chats[chatIndexToPatch], ...action.payload }
        draft.currentChat = draft.chats[chatIndexToPatch]
      }
      break;
    case ActionType.UNSHIFT_CURRENT_CHAT:
      if( draft.currentChat != null ){
        let chatIndexToUnshift = draft.chats.findIndex(chat => chat.id === draft.currentChat?.id)
        draft.chats.splice(chatIndexToUnshift, 1);
        draft.chats.unshift(draft.currentChat);
      }
      break;
    default:
      break;
  }
}, initialState);

export default chatReducer;